import { render, staticRenderFns } from "./CherkizovoCardAgreeButtons.vue?vue&type=template&id=a4816b8c"
import script from "./CherkizovoCardAgreeButtons.vue?vue&type=script&lang=js"
export * from "./CherkizovoCardAgreeButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports